import {Component} from '@angular/core';
import {AuthService} from "@app/auth/auth.service";

@Component({template: ''})
export class LoginComponent {
    constructor(
        private authService: AuthService
    ) {
        this.authService.redirectToIdp();
    }
}
